import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-logout',
  templateUrl: './logout.component.html'
})
export class LogoutComponent {
  readonly sessionExpiredDueToInactivityMessage = $localize`:@@oneportal.inacitvityLogout.message:Due to inactivity, your page has expired. Please refresh`;
}
